import { render, staticRenderFns } from "./diagnosis-info.vue?vue&type=template&id=1a23d576&scoped=true&"
import script from "./diagnosis-info.vue?vue&type=script&lang=js&"
export * from "./diagnosis-info.vue?vue&type=script&lang=js&"
import style0 from "./diagnosis-info.vue?vue&type=style&index=0&id=1a23d576&scoped=true&lang=less&"
import style1 from "./diagnosis-info.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23d576",
  null
  
)

export default component.exports